




























import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
@Component
export default class ComboField extends Vue {
  @Prop({ type: Object, required: true }) row!: { [key: string]: string[] };
  @Prop({ type: Function }) onClick!: Function;
  @Prop({ type: Boolean, default: false }) isDisabled!: boolean;
  @Prop({ type: Boolean }) isComponentError!: boolean;
  @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;

  get options() {
  return Object.entries(this.row.comboValues)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) =>
      {
        return a.value.localeCompare(b.value, undefined, { numeric: true });
      }
    );
  }

  handleClick() {
    if (this.onClick) {
      this.onClick(this.row.tip);
    }
  }
 
}
